<template>
  <div class="dialog_container">
    <el-dialog
      title="新增车辆维修记录"
      :visible="dialogShow"
      width="837px"
      @close="dialogClose"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="form_title">基本信息</div>
        <el-form
          ref="addForm"
          class="add_staff_form"
          :model="addForm"
          label-width="130px"
          :rules="addRules"
        >
          <el-form-item label="车牌号码：" prop="carId">
            <el-select
              v-model="addForm.carId"
              placeholder="请选择车辆"
              @change="carChange"
            >
              <el-option
                v-for="item in carList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌颜色：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="carColor"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆类型：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="carType"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="厂牌型号：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="carModel"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆营运性质：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="carNature"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="车主单位：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="carUnit"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="维修状态：">
            <el-input
              placeholder="选择车辆后自动填充"
              v-model="addForm.state"
              disabled
            ></el-input>
          </el-form-item>

          <div class="form_title">维修信息</div>
          <el-form-item label="维修企业：" prop="repairCompanyName">
            <el-input
              v-model="addForm.repairCompanyName"
              placeholder="请输入维修企业"
            ></el-input>
          </el-form-item>
          <el-form-item label="进厂时间：" prop="factoryTimeStr">
            <el-date-picker
              type="datetime"
              placeholder="选择进厂时间"
              v-model="addForm.factoryTimeStr"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="进厂里程数：">
            <el-input
              v-model="addForm.factoryMile"
              placeholder="请输入进厂里程数"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="form_title">图片及附件</div>
        <div class="uploading_box">
          <div class="certificate">
            <div class="upload_img_box">
              <div class="card_title">进厂图片</div>
              <div v-if="addForm.factoryImage" class="onebox">
                <div
                  class="twobox"
                  v-if="addForm.factoryImage.indexOf('.pdf') != -1"
                >
                  <el-image
                    class="avatar_img_pd"
                    src="../../../../static/images/pdf_icon.png"
                  ></el-image>
                </div>
                <el-image
                  v-else
                  :src="imgHttp + addForm.factoryImage"
                  class="avatar_img"
                />
              </div>
              <div class="onebox" v-else>
                <div class="twobox">
                  <img
                    class="avatar_img_pd"
                    src="../../../../static/images/idCard_icon.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="btns_box">
                <div class="img_btns">
                  <el-upload
                    class="avatar-uploader_btn"
                    action="http://47.101.220.89:8687/file/uploadFile"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                    :headers="headers"
                    :http-request="uploadFile"
                  >
                    <el-button class="img_btn">{{
                      addForm.factoryImage ? "变更" : "上传"
                    }}</el-button>
                  </el-upload>
                </div>
                <el-button
                  class="img_btn"
                  v-if="
                    addForm.factoryImage &&
                    addForm.factoryImage.indexOf('.pdf') != -1
                  "
                  :disabled="!addForm.factoryImage ? true : false"
                >
                  <a
                    class="img_a"
                    :href="imgHttp + addForm.factoryImage"
                    target="_blank"
                    rel="noopener noreferrer"
                    >预览</a
                  >
                </el-button>
                <el-button
                  v-else
                  class="img_btn"
                  :disabled="!addForm.factoryImage ? true : false"
                  @click="handlePictureCardPreview"
                  >预览</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="
                    !addForm.factoryImage ||
                    addForm.factoryImage.indexOf('.pdf') != -1
                      ? true
                      : false
                  "
                  @click="downs"
                  >下载</el-button
                >
                <el-button
                  class="img_btn"
                  :disabled="!addForm.factoryImage ? true : false"
                  @click="handleRemove"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('addForm')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <preview-image
      :show.sync="dialogVisible"
      :name="dialogImageName"
      :url="dialogImageUrl"
    />
  </div>
</template>

<script>
import { timestampToTime, downloadFile } from "@/utils/util";
import config from "@/utils/config";
import previewImage from "@/components/previewImage.vue";
export default {
  name: "",
  data() {
    return {
      textarea: "",
      addForm: {},
      receiveList: [],
      addRules: {
        carId: [{ required: true, message: "请选择车辆", trigger: "change" }],
        repairCompanyName: [
          { required: true, message: "请输入维修企业", trigger: "blur" },
        ],
        factoryTimeStr: [
          { required: true, message: "请选择进厂时间", trigger: "change" },
        ],
      },
      carColor: "",
      carType: "",
      carModel: "",
      carNature: "",
      carUnit: "",
      carList: [],
      headers: {},
      imgHttp: "",
      dialogImageUrl: "",
      dialogImageName: "",
      dialogVisible: false,
    };
  },
  components: {
    previewImage,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.headers = {
      Authorization: sessionStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
    this.imgHttp = config.baseUrl;
    this.addForm.state = "返修送检";
    this.$http.getRepairSelect(3).then((res) => {
      if (res.code === 0) {
        this.carList = res.data;
      }
    });
  },
  methods: {
    carChange(e) {
      console.log(e);
      this.carList.forEach((i) => {
        if (i.id == e) {
          this.carColor = i.carColorStr || " ";
          this.carType = i.carTypeStr || " ";
          this.carModel = i.carFactoryModel || " ";
          this.carNature = i.carServiceStr || " ";
          this.carUnit = i.companyName || " ";
        }
      });
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.addForm.factoryTimeStr = timestampToTime(
          this.addForm.factoryTimeStr
        );
        this.$http.addRepair(this.addForm).then((res) => {
          if (res.code === 0) {
            this.$message.success(res.msg);
            this.$parent.getList();
            this.addForm = {};
            this.$emit("update:dialogShow", false);
          } else {
            this.$message.info(res.msg);
          }
        });
      });
    },
    dialogClose() {
      this.addForm = {}
      this.$emit("update:dialogShow", false);
    },
    uploadFile(file) {
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);
      this.$http.uploadFile(formData).then((res) => {
        this.addForm.factoryImage = res.msg;
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isType =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "application/pdf"
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isType || !isLt20M) {
        this.$message.error(
          "请上传格式为jpg、jpeg、png、pd且大小不超过20M的图片或文件"
        );
      }
      return isType && isLt20M;
    },
    handlePictureCardPreview() {
      let url = this.addForm.factoryImage;
      let name = "进厂图片";
      this.dialogImageUrl = this.imgHttp + url;
      this.dialogImageName = name;
      this.dialogVisible = true;
    },
    downs() {
      let url = this.addForm.factoryImage;
      let name = "进厂图片";
      downloadFile(this.imgHttp + url, name);
    },
    handleRemove() {
      console.log(222);
      this.addForm.factoryImage = "";
       this.$forceUpdate();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
.uploading_box {
  display: flex;
  flex-wrap: wrap;
  .certificate {
    width: 360px;
    height: 270px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    margin-bottom: 3px;
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader {
      width: 100%;
      height: 100%;
      border-radius: 2px;
      border: 1px solid #d1d1d1;
      display: flex;
      justify-content: center;
      align-items: center;
      .card_title {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      .uploading_icon {
        width: 91px;
        height: 70px;
        margin-top: 15px;
      }

      .img_box {
        width: 238px;
        height: 157px;
        .avatar {
          width: 100%;
          height: 100%;
          margin-top: 0;
        }
      }
    }
  }
  .card_title {
        width: 100%;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        >img{
            width: 6px;
            height: 6px;
        }
      }
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/maintainRecord_component/addCarMaintain.vue